namespace Controlli {
    export namespace Overlay {

        let oggetto: JQuery<HTMLElement>;

        const Show_Event: string = "Overlay_ShowEvent";
        const Hide_Event: string = "Overlay_HideEvent";

        export function Initialize(): void {
            oggetto = $(".overlay");
            oggetto.on("click", (event) => Hide());
        }

        export function Show(triggerEvent: boolean = true): void {
            oggetto.show(0, function () {
                oggetto.stop().fadeTo(500, 0.5);
            });

            if (triggerEvent)
                $(document).trigger("Overlay_ShowEvent", null);
        }

        export function Hide(triggerEvent: boolean = true): void {
            oggetto.stop().fadeTo(500, 0, function () {
                oggetto.hide();
            });

            if (triggerEvent)
                $(document).trigger("Overlay_HideEvent", null);
        }

    }
}